import Collection from "../../../data-structures/collection"
import FinderTaskModel from "./finder-task-model"

export default class FinderTasksCollection extends Collection<FinderTaskModel> {

    constructor(models:any) {
        super(models)
    }

    static initFromJson(tasksData: JSONArray):FinderTasksCollection {
        const subtasks:any      = {}

        const models : FinderTaskModel[] = _.map(tasksData, (taskData:any)=>{

            const model = new FinderTaskModel(taskData)

            if (taskData.parentTaskId) {
                if (!subtasks.hasOwnProperty(taskData.parentTaskId)) {
                    subtasks[taskData.parentTaskId] = []
                }

                subtasks[taskData.parentTaskId].push(model)
            }

            return model
        })

        _.map(models, model=>{
            if (subtasks.hasOwnProperty(model.id)) {
                model.subtasks = _.orderBy(subtasks[model.id], t=>t.sortPosition)
                delete subtasks[model.id]
            }
        })

        return new FinderTasksCollection(models)
    }

    get rootModels() {
        return _.filter(this.models, model=>!model.parentTaskId || !this.get(model.parentTaskId))
    }

    add(model: FinderTaskModel) {
        if (this.get(model.id)) {
            this.replace(model.id, model)
        } else {
            super.add(model)
        }
    }
}